import PuidsContext from 'core/components/Ad/puids';

export default function withPuids(Component) {
  return function PuidsComponent(props) {
    return (
      <PuidsContext.Consumer>
        {puids => {
          return <Component {...props} puids={{ ...puids }} />;
        }}
      </PuidsContext.Consumer>
    );
  };
}
